import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { CopyJobTemplateModal } from 'components/modals/CopyJobTemplateModal/CopyJobTemplateModal'
import { DeleteJobTemplateModal } from 'components/modals/DeleteJobTemplateModal/DeleteJobTemplateModal'
import { PositionTemplateManagementModal } from 'components/modals/PositionTemplateManagementModal/PositionTemplateManagementModal'
import { Button } from 'components/shared/Button/Button'
import { Pane } from 'components/shared/Pane/Pane'
import { SearchWidget } from 'components/shared/SearchWidget/SearchWidget'
import { JobsTable } from './common/JobsTable'
import { DepartmentFilter } from 'components/shared/DepartmentFilter/DepartmentFilter'
import { useJobTemplates } from './hooks'
import { PlusCircleIcon } from 'components/shared/Icon/model'

import styles from './Jobs.module.scss'

export const Jobs = () => {
  const { state, handlers } = useJobTemplates()

  const {
    search,
    template,
    isCopyJobTemplateOpen,
    isDeleteJobTemplateOpen,
    isManagementJobTemplateOpen,
    departmentValue,
    filter,
  } = state
  const {
    handleCopyJobTemplateClose,
    handleCopyJobTemplateConfirm,
    handleDeleteJobTemplateClose,
    handleDeleteJobTemplateConfirm,
    handleManagementJobTemplateClose,
    handleManagementJobTemplateConfirm,
    handleManagementJobTemplateOpen,
    setDepartment,
    handleCopy,
    handleDelete,
    handleEdit,
    setSearch,
  } = handlers

  return (
    <>
      <Pane.Header className={styles.header}>
        <DepartmentFilter
          value={departmentValue}
          onChange={setDepartment}
          className={styles.departmentFilter}
        />
        <SearchWidget query={search} onChange={setSearch} />
        <Box>
          <Button
            className={styles.button}
            color="primary"
            icon={PlusCircleIcon}
            label={t`Job template`}
            size="small"
            variant="filled"
            onClick={handleManagementJobTemplateOpen}
          />
        </Box>
      </Pane.Header>
      <JobsTable
        {...{ search, filter, handleCopy, handleDelete, handleEdit }}
      />
      {isManagementJobTemplateOpen ? (
        <PositionTemplateManagementModal
          onCancel={handleManagementJobTemplateClose}
          onClose={handleManagementJobTemplateClose}
          onConfirm={handleManagementJobTemplateConfirm}
          isOpen={isManagementJobTemplateOpen}
          {...{ template }}
        />
      ) : null}
      <CopyJobTemplateModal
        onCancel={handleCopyJobTemplateClose}
        onClose={handleCopyJobTemplateClose}
        onConfirm={handleCopyJobTemplateConfirm}
        isOpen={isCopyJobTemplateOpen}
        {...{ template }}
      />
      <DeleteJobTemplateModal
        onCancel={handleDeleteJobTemplateClose}
        onClose={handleDeleteJobTemplateClose}
        onConfirm={handleDeleteJobTemplateConfirm}
        isOpen={isDeleteJobTemplateOpen}
      />
    </>
  )
}
